"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contractInterfaceId = void 0;

var _utils = require("../utils");

var _contractInterfaces = require("./contract-interfaces");

const contractInterfaceId = {
  TradeTrustTokenMintable: (0, _utils.computeInterfaceId)(_contractInterfaces.contractInterfaces.TradeTrustTokenMintable),
  TradeTrustTokenBurnable: (0, _utils.computeInterfaceId)(_contractInterfaces.contractInterfaces.TradeTrustTokenBurnable),
  TradeTrustTokenRestorable: (0, _utils.computeInterfaceId)(_contractInterfaces.contractInterfaces.TradeTrustTokenRestorable),
  TitleEscrow: (0, _utils.computeInterfaceId)(_contractInterfaces.contractInterfaces.TitleEscrow),
  TitleEscrowSignable: (0, _utils.computeInterfaceId)(_contractInterfaces.contractInterfaces.TitleEscrowSignable),
  TitleEscrowFactory: (0, _utils.computeInterfaceId)(_contractInterfaces.contractInterfaces.TitleEscrowFactory),
  AccessControl: (0, _utils.computeInterfaceId)(_contractInterfaces.contractInterfaces.AccessControl),
  SBT: (0, _utils.computeInterfaceId)(_contractInterfaces.contractInterfaces.SBT)
};
exports.contractInterfaceId = contractInterfaceId;